import { AddressBook, Package } from "@phosphor-icons/react";
import { MasterPanel } from "../components/masters/MasterPanel";

const CUSTOMER_FIELDS = [
  { key: "name", label: "Customer name" },
  { key: "location", label: "Location" },
  { key: "id_type", label: "ID Type", type: "select", options: [["aadhaar", "Aadhaar"], ["gst", "GST"]] },
  { key: "id_number", label: "Aadhaar / GST number" },
];
const PRODUCT_FIELDS = [{ key: "name", label: "Product name" }];

export default function Masters() {
  return (
    <div data-testid="masters-page" className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 md:text-3xl">Masters</h1>
        <p className="mt-1 text-sm text-slate-500">
          Manage customers and products. New names used in orders are added here automatically.
        </p>
      </div>
      <div className="grid gap-6 xl:grid-cols-2">
        <MasterPanel title="Customers" icon={AddressBook} endpoint="customers" testPrefix="customer" importer
          importHint="Excel with columns: Customer Name, Location, Aadhaar, GST. Duplicates are skipped automatically."
          fields={CUSTOMER_FIELDS} />
        <MasterPanel title="Products" icon={Package} endpoint="products" testPrefix="product" bulk importer
          importHint="Excel with product names in the first column (one per row)"
          fields={PRODUCT_FIELDS} />
      </div>
    </div>
  );
}
